import React, { useCallback, useMemo, useState } from "react";
import { useAxios } from "../../hooks";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import NoRowOverlay from "../common/NoRowOverlay";
import { Box, Tooltip, IconButton } from "@mui/material";
import { getDateTime } from "../../utilities/getDateTime";
import ComfirmDialog from "../common/ConfirmDialog";
import ReplayIcon from "@mui/icons-material/Replay";

const FailedOrder = ({ handleOnSelecting }) => {
  const api = useAxios({ autoSnackbar: true });
  const queryClient = useQueryClient();

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [data, setData] = useState({ order_id: "" });

  const handleConfirmOpen = useCallback(() => {
    setConfirmOpen((prev) => !prev);
  }, []);

  const { data: res, isLoading } = useQuery(
    `order-list_failed_page=${page}_rowsPerPage=${pageSize}`,
    () => {
      return api.get(
        `/api/order/i/FAILED/p?page=${page}&rowsPerPage=${pageSize}`
      );
    }
  );

  const { mutate } = useMutation(
    () => {
      return api.patch(`/api/order/i/payment/retry/${data.order_id}`);
    },
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries(
          `order-list_failed_page=${page}_rowsPerPage=${pageSize}`
        );
      },
    }
  );

  const columns = useMemo(
    () => [
      { field: "id", headerName: "ID", minWidth: 90, flex: 0.5 },
      {
        field: "order_number",
        headerName: "Order Number",
        minWidth: 100,
        flex: 1,
      },
      {
        field: "company_name",
        headerName: "Company Name",
        minWidth: 100,
        flex: 1,
      },
      {
        field: "package_name",
        headerName: "Package Name",
        minWidth: 100,
        flex: 1,
      },
      {
        field: "package_credit",
        headerName: "Package Credit",
        minWidth: 100,
        flex: 1,
      },
      {
        field: "package_price",
        headerName: "Package Price",
        minWidth: 100,
        flex: 1,
      },
      { field: "package_tax", headerName: "Tax", minWidth: 100, flex: 1 },
      {
        field: "created_at",
        headerName: "Created At",
        minWidth: 100,
        flex: 1,
        valueFormatter: (params) => getDateTime(params.value),
      },
      {
        field: "action",
        headerName: "Action",
        sortable: false,
        minWidth: 100,
        flex: 1,
        renderCell: (params) => (
          <Box
            sx={{ display: "flex", alignItems: "center", textAlign: "center" }}
          >
            <Tooltip title="Move To Pending">
              <IconButton
                color="success"
                size="small"
                onClick={() => {
                  setData({
                    order_id: params.id,
                  });
                  handleConfirmOpen();
                }}
              >
                <ReplayIcon
                  sx={{
                    cursor: "pointer",
                  }}
                />
              </IconButton>
            </Tooltip>
          </Box>
        ),
      },
    ],
    []
  );

  return (
    <>
      <DataGrid
        columns={columns}
        rowCount={res?.data?.total ?? 0}
        rows={res?.data?.rows ?? []}
        loading={isLoading}
        pagination
        paginationMode="server"
        checkboxSelection
        onSelectionModelChange={handleOnSelecting}
        page={page}
        pageSize={pageSize}
        onPageChange={(v) => setPage(v)}
        onPageSizeChange={(v) => setPageSize(v)}
        components={{
          Toolbar: GridToolbar,
          NoRowsOverlay: NoRowOverlay,
        }}
      />
      <ComfirmDialog
        open={confirmOpen}
        handleClose={handleConfirmOpen}
        handleOnConfirm={mutate}
      />
    </>
  );
};

export default FailedOrder;
